import type { RouterConfig } from '@nuxt/schema';

export default {
  routes: routes => routes.map((route) => {
    const decoded = decodeURIComponent(route.path);
    if (decoded === route.path) return route;
    return {
      ...route,
      path: decoded,
      alias: route.path,
    };
  }),
} satisfies RouterConfig;
